import type { ChangeEvent, Dispatch, FC, SetStateAction } from 'react'
import { useEffect, useState } from 'react'
import {
  CwsCheckbox,
  CwsDivider,
  CwsGrid,
  CwsGridCol,
  CwsGridRow,
  CwsInput,
  CwsLabel,
  CwsSelect,
  CwsSelectOption,
  CwsTextarea,
} from '@components/cws'
import { useTranslate } from '@hooks/useTranslation'
import { useRouter } from 'next/router'

export const deliveries = ['Platinum Lounge', 'Car Deck'] as const

export type PlatinumLoungeData = {
  name: string
  clubOne: string
  deliveryPoint: typeof deliveries[number]
  message?: string
}

interface PlatinumLoungeContentProps {
  setTermsAccepted(param: boolean): void
  data: PlatinumLoungeData
  setData: Dispatch<SetStateAction<PlatinumLoungeData>>
}

const PlatinumLoungeContent: FC<PlatinumLoungeContentProps> = ({ setTermsAccepted, setData, data }) => {
  const { translate } = useTranslate()
  const { locale } = useRouter()
  const [localDelivery, setLocalDelivery] = useState<typeof deliveries[number]>('Platinum Lounge')
  const changeHandler = (field: keyof PlatinumLoungeData) => (value: string) => {
    setData((prevState) => ({ ...prevState, [field]: value }))
  }

  useEffect(() => {
    setData((prevState) => ({ ...prevState, ['deliveryPoint']: localDelivery }))
  }, [localDelivery, setData])

  return (
    <CwsGrid width="fluid" className="cws-mt-40">
      <CwsGridRow justifyContent="left">
        <CwsGridCol col="12" lg="6">
          <CwsLabel>{translate('platinum.lounge.name.label')}</CwsLabel>
          <CwsInput value={data.name} onChange={changeHandler('name')} />
        </CwsGridCol>
      </CwsGridRow>
      <CwsGridRow justifyContent="left">
        <CwsGridCol col="12" lg="6" className="cws-mt-20">
          <CwsLabel>{translate('platinum.lounge.co.label')}</CwsLabel>
          <CwsInput value={data.clubOne} onChange={changeHandler('clubOne')} />
        </CwsGridCol>
      </CwsGridRow>
      <CwsGridRow verticalAlign="center" justifyContent="left">
        <CwsGridCol className="cws-mt-20" col="12" lg="6">
          <CwsLabel>{translate('platinum.lounge.delivery.location.label')}</CwsLabel>
          <CwsSelect id="platinum-lounge-delivery" value={localDelivery} onChange={setLocalDelivery}>
            {deliveries.map((place) => (
              <CwsSelectOption key={place} value={place} title={place} />
            ))}
          </CwsSelect>
        </CwsGridCol>
        <CwsGridCol col="12">
          <CwsLabel>{translate('platinum.lounge.comment.label')}</CwsLabel>
          <CwsTextarea
            locale={locale}
            onChange={changeHandler('message')}
            optional
            label={translate('platinum.lounge.comment.label')}
            maxLength={200}
          />
        </CwsGridCol>
      </CwsGridRow>
      <CwsDivider color="medium-grey" spacing="l" key="separator" />

      <CwsCheckbox id="confirm-order-check" onChange={(value: boolean) => setTermsAccepted(value)}>
        {translate('platinum.lounge.terms.text')}
      </CwsCheckbox>
    </CwsGrid>
  )
}

export default PlatinumLoungeContent
